import { Head, useForm, usePage } from '@inertiajs/react'
import Layout from '../components/Layout'
import Avatar from '../components/Avatar'
import NotificationSettings from '../components/NotificationSettings'

export default function Account() {
  const { currentUser } = usePage().props
  const { data, setData, patch, processing, errors, reset } = useForm({
    current_password: '',
    password: '',
    password_confirmation: '',
  })

  function submit(event) {
    event.preventDefault()
    patch('/account', { onSuccess: () => reset() })
  }

  return (
    <Layout>
      <Head title="Your account" />

      <div className="mx-auto max-w-xl">
        <div className="card-cute mb-6 flex items-center gap-4 p-6">
          <Avatar initials={currentUser?.initials} size="lg" />
          <div>
            <h1 className="font-display text-2xl font-extrabold text-ink">{currentUser?.name}</h1>
            <p className="text-ink-soft">
              @{currentUser?.username}
              {currentUser?.relation ? ` · ${currentUser.relation}` : ''}
            </p>
            <p className="text-sm text-ink-soft/80">{currentUser?.email}</p>
          </div>
        </div>

        <div className="mb-6">
          <NotificationSettings />
        </div>

        <form onSubmit={submit} className="card-cute space-y-5 p-6">
          <h2 className="font-display text-2xl font-extrabold text-ink">Change your password 🔑</h2>

          <div>
            <label htmlFor="current_password" className="mb-1.5 block font-display font-bold text-ink-soft">
              Current password
            </label>
            <input
              id="current_password"
              type="password"
              value={data.current_password}
              onChange={(event) => setData('current_password', event.target.value)}
              required
              maxLength={72}
              autoComplete="current-password"
              className="input-cute"
            />
            {errors.current_password && (
              <p className="mt-1 text-sm font-bold text-rose-600">{errors.current_password}</p>
            )}
          </div>

          <div>
            <label htmlFor="password" className="mb-1.5 block font-display font-bold text-ink-soft">
              New password
            </label>
            <input
              id="password"
              type="password"
              value={data.password}
              onChange={(event) => setData('password', event.target.value)}
              required
              maxLength={72}
              autoComplete="new-password"
              placeholder="At least 8 characters"
              className="input-cute"
            />
            {errors.password && <p className="mt-1 text-sm font-bold text-rose-600">{errors.password}</p>}
          </div>

          <div>
            <label htmlFor="password_confirmation" className="mb-1.5 block font-display font-bold text-ink-soft">
              Confirm new password
            </label>
            <input
              id="password_confirmation"
              type="password"
              value={data.password_confirmation}
              onChange={(event) => setData('password_confirmation', event.target.value)}
              required
              maxLength={72}
              autoComplete="new-password"
              className="input-cute"
            />
            {errors.password_confirmation && (
              <p className="mt-1 text-sm font-bold text-rose-600">{errors.password_confirmation}</p>
            )}
          </div>

          <p className="text-sm text-ink-soft/80">Changing your password signs you out everywhere else.</p>

          <button type="submit" disabled={processing} className="btn-cute bg-blush-400 text-white shadow hover:bg-blush-500">
            Update password
          </button>
        </form>
      </div>
    </Layout>
  )
}
